export default __webpack_public_path__ + "../staticImages/sprite-hermeslogo_mini-2x.png";